import { clearPin, dropPin } from './search';
import { loadLocationInfo } from './database';

import createBillboard from '~app/core/createBillboard';
import * as LocalStorage from '~app/core/localStorage';
import Location from '~app/core/location';

export const ADD_FAVORITE = 'ADD_FAVORITE';
export const REMOVE_FAVORITE = 'REMOVE_FAVORITE';

const favoritePinImage = require('~app/resources/images/billboards/Pin_Favorite.png');

export function restoreFavorites(updateProgress) {
  return async (dispatch, getState) => {
    const savedLocations = LocalStorage.deserializeFavorites();
    const locationInfos = await Promise.all(
      savedLocations.map(rawData => {
        const location = new Location([rawData.lon, rawData.lat], rawData.displayName);
        return dispatch(loadLocationInfo(location))
          .then(result => {
            updateProgress();
            return result;
          });
      })
    );

    for (const locationInfo of locationInfos) {
      // Invoke the doAddFavorite action creator directly instead of using the
      // addFavorite action creator. Since we know we are loading the serialized
      // favorites, we don't need to clear pins and re-serialize the favorites
      // like we do for a user-initiated addFavorite call.
      dispatch(doAddFavorite(locationInfo));
    }
  };
}

export function countFavorites() {
  const savedLocations = LocalStorage.deserializeFavorites();
  return savedLocations.length;
}

export function addFavorite(locationInfo) {
  return (dispatch) => {
    dispatch(clearPin(locationInfo.location));
    dispatch(doAddFavorite(locationInfo));
    dispatch(serializeFavorites());
  };
}

// This is a private helper action creator that only adds the favorite to the
// store. It doesn't do the full user-initiated action sequence.
function doAddFavorite(locationInfo) {
  return {
    type: ADD_FAVORITE,
    locationInfo,
    marker: createFavoriteMarker(locationInfo),
  };
}

export function removeFavorite(locationInfo) {
  return (dispatch, getState) => {
    dispatch(dropPin(locationInfo.location));

    // Look up the marker instance corresponding to this location.
    const state = getState();
    const index = state.favorites.locationInfos.indexOf(locationInfo);
    if (index >= 0) {
      const marker = state.favorites.favoriteMarkers[index];
      dispatch({
        type: REMOVE_FAVORITE,
        locationInfo,
        marker,
      });
      dispatch(serializeFavorites());
    }
  };
}

// This action creator does not modify the store, but we need to dispatch it
// to get a getState hook that can provide the state after add/removeFavorite
// applies their change to the store.
function serializeFavorites() {
  return (dispatch, getState) => {
    const locationInfos = getState().favorites.locationInfos;
    LocalStorage.serializeFavorites(locationInfos);
  };
}

export function isFavoriteLocationInfo(locationInfo, favorites) {
  const index = favorites.findIndex(favoriteLocationInfo =>
    favoriteLocationInfo === locationInfo);

  return (index !== -1);
}

export function getFavoriteLocationInfo(location, favorites) {
  const index = favorites.findIndex(favoriteLocationInfo =>
    favoriteLocationInfo.location.equals(location));

  return (index !== -1) ? favorites[index] : null;
}

export function createFavoriteMarker(locationInfo) {
  return createBillboard(
    locationInfo.location,
    favoritePinImage,
    {
      scale: 1.5,
      verticalOrigin: "center",
    }
  );
}



// WEBPACK FOOTER //
// ./src/actions/favorites.js